import { request } from "../utils/request.js"

export const customerBalanceDetail_findPageByCustomer = (pojo, args) => request({
    url: 'customerBalanceDetail/findPageByCustomer',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customerBalanceDetail_findById = (id, args) => request({
    url: 'customerBalanceDetail/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customerBalanceDetail.js